import { create } from 'zustand';

/**
 * Globale store voor de invoice-detail drawer. Mirror van
 * order-detail-drawer-store / wasserij-item-drawer-store. Geen URL-sync; deep
 * links gaan via /facturen/:id route.
 */
interface InvoiceDetailDrawerState {
  openInvoiceId: string | null;
  open: (id: string) => void;
  close: () => void;
}

export const useInvoiceDetailDrawerStore = create<InvoiceDetailDrawerState>((set) => ({
  openInvoiceId: null,
  open: (id) => set({ openInvoiceId: id }),
  close: () => set({ openInvoiceId: null }),
}));
